import React from "react";
import { Flame, AlertTriangle } from "lucide-react";

export function StreakBanner({ dc }) {
  if (dc.streak == null) return null;
  if (dc.missed_days > 0 && !dc.completed) {
    const n = dc.missed_days;
    return (
      <div className="flex items-center gap-3 rounded-md border border-amber-400/40 bg-amber-500/10 p-4 text-sm text-amber-100" data-testid="streak-nudge">
        <AlertTriangle size={18} className="shrink-0 text-amber-300" />
        <div>
          <div className="font-semibold">
            <span className="font-mono-num" data-testid="missed-days">{n >= 60 ? "60+" : n}</span> day{n === 1 ? "" : "s"} missed — answer today to {n >= 3 ? "restart" : "save"} your streak.
          </div>
          <div className="mt-0.5 text-xs text-amber-200/70">It takes under a minute. Your teacher can see long gaps.</div>
        </div>
      </div>
    );
  }
  return (
    <div className="inline-flex items-center gap-2 rounded-md border border-orange-400/30 bg-orange-500/5 px-4 py-2 text-sm text-orange-100" data-testid="streak-chip">
      <Flame size={14} className="text-orange-300" />
      <span className="font-mono-num font-semibold" data-testid="streak-days">{dc.streak}</span> day streak
      {!dc.completed && dc.streak > 0 && <span className="text-xs text-orange-200/70">· answer today to keep it</span>}
      {dc.completed && <span className="text-xs text-lime-300">· done for today ✓</span>}
    </div>
  );
}
